<template>
    <form class="announcement-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['type_name']}">
            <label for="name" class="col-sm-2 control-label">Nombre *</label>
            <div class="col-sm-10">
                <input type="text" :maxlength="190" class="form-control" id="name" v-model="data.type_name">
                <div class="help-block" v-for="e in errors['type_name']">{{e}}</div>
            </div>
        </div>        
 
        <div class="form-group" :class="{'has-error': errors['status']}">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.status" on-text="SI" off-text="NO"></el-switch>
                <div class="help-block" v-for="e in errors['status']">{{e}}</div>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/faqs/'+this.faq.id">Cancelar</a>
                <button type="submit" class="btn btn-primary" :disabled="disabled">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    
    .el-date-picker{
        display: block;
    }
    .el-select{
        display: block;
    }

    .card * {
        font-weight: normal;
    }
    .cards-grid {
        list-style: none;
        padding: 0px;
        margin: 0px;
    }
    .cards-grid a {
        text-decoration: none;
    }
    *, :after, :before {
        box-sizing: border-box;
    }
    @media (min-width: 992px){
        .col-md-6 {
            width: 50%;
        }
    }
    .cards-grid li {
        list-style: none;
        margin: 0px;
        padding: 0px 10px;
    }
    .cards-grid li article h2 {
        font-family: 'Roboto Slab';
        padding: 100px 0px 10px 0px;
        color: #000;
        font-size: 22px !important;
        padding-right: 120px;

        margin-top: 20px;
        margin-bottom: 10px;
    }
    .cards-grid li article h2 {
        color: #000;
        font-size: 22px!important;
        padding: 20px 120px 30px 0px !important;
    }
    .cards-grid li article h2 strong {
        font-weight: 600!important;
    }
    .cards-grid article.card {
        position: relative;
        max-height: 133px;
        top: 0px;
        transition: top, 0.3s, box-shadow, 0.3s;
    }
    .cards-grid li article {
        height: auto;
    }
    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        width: 550px;
        min-height: 133px;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: none;
        border-radius: 10px;
        padding: 12px 18px 18px;
        margin-bottom: 25px;
        font-weight: 400;
        overflow: hidden;
        -webkit-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        -moz-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
    }

    .cards-grid li article span {
        font-size: 110px;
        position: absolute;
        right: 20px;
        top: 20px;
    }


    @font-face {
        font-family: 'covid';
        src:  url('/fonts/covid.eot?j0o9fh');
        src:  url('/fonts//covid.eot?j0o9fh#iefix') format('embedded-opentype'),
        url('/fonts/covid.ttf?j0o9fh') format('truetype'),
        url('/fonts/covid.woff?j0o9fh') format('woff'),
        url('/fonts/covid.svg?j0o9fh#covid') format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: block;
    }
    
    [class^="icon-icon"], [class*=" icon-icon"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'covid' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
    
        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    

    .icon-icon-escuela:before {
        content: "\e904";
        color: #0f69b4;
    }
    .icon-icon-estudio:before {
        content: "\e905";
        color: #0f69b4;
    }
    .icon-icon-migracion:before {
        content: "\e906";
        color: #0f69b4;
    }
    .icon-icon-salud:before {
        content: "\e907";
        color: #0f69b4;
    }
    .icon-icon-trabajo:before {
        content: "\e908";
        color: #0f69b4;
    }
    .icon-icon-viaje:before {
        content: "\e909";
        color: #0f69b4;
    }
    .icon-icon-flecha:before {
        content: "\e903";
        color: #0f69b4;
    }
    .icon-icon-coronavirus-blanco:before {
        content: "\e902";
        color: #fff;
    }
    .icon-icon-escudo:before {
        content: "\e900";
        color: #0f69b4;
    }
    .icon-icon-coronavirus:before {
        content: "\e901";
        color: #0f69b4;
    }

    /*Agregar estas dos reglas a la lista de la familia 'covid' en etapas_corona.css, línea 953*/
    .icon-icon-documento:before {
        content: "\e90a";
        color: #0f69b4;
    }
    .icon-icon-pyme:before {
        content: "\e90b";
        color: #0f69b4;
    }
    .icon-icon-huaso:before {
        content: "\e913";
        color: #0f69b4;
    }
    .icon-icon-canasta:before {
    content: "\E90C";
    color: #0f69b4;
    }
    .icon-icon-news:before {
    content: "\E90D";
    color: #0f69b4;
    }
    .icon-icon-beneficios:before {
    content: "\E90E";
    color: #0f69b4;
    }
    .icon-icon-sofa:before {
    content: "\E90F";
    color: #0f69b4;
    }
    .icon-icon-judicial:before {
    content: "\E911";
    color: #0f69b4;
    }
    .icon-icon-cuarentena:before {
    content: "\E910";
    color: #0f69b4;
    }
    .icon-icon-presencial:before {
    content: "\E912";
    color: #0f69b4;
    }
  
</style>
<script>
    import Vue from 'vue';
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';
    import { Message } from "element-ui";
    import { Loading } from 'element-ui';
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                type_name: '',
                status: false,
                created_at: null,
                updated_at: null,
            };
            
            return{
                data: _.assign(data, this.type),
                disabled: false,
                must_delete: false,
                errors: {},
                loading: false
            }
        },
        props: ['faq','type', 'total_topics_type','edit'],
        computed: {
        },
        methods:{
            submit: function(){
                var self = this;


                var errores = {};

                if (!self.data.type_name || self.data.type_name.length == 0) {
                    errores["type_name"] = ["Debe ingresar el Nombre del tipo"];
                }
                if (/^\s+$/.test(self.data.type_name)){
                  errores["type_name"] = ["El nombre no puedes ser solo espacios en blanco ."];
                }
                if (_.size(errores) > 0 || self.disabled == true) {
                    self.errors = errores;
                    self.$message.error(
                    "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }else{
                    console.log('SE ENVIARA EL FORMULARIO')
                    axios({
                        url: self.edit ? 'backend/faqs/'+self.faq.id+'/types/'+self.data.id : 'backend/faqs/'+self.faq.id+'/types/',
                        method: self.edit ? 'PUT' : 'POST',
                        data: self.data,
                    }).then(function(response){
                        self.$loading().close();
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        self.$loading().close();
                        self.errors = error.response.data.errors;
                    });
                }
            },
        },
        components:{
            ElSelect,
            ElOption,
        },
        mounted() {
        }
    }
</script>